/* ============================================================
   COLLECTION AKHAVAN — Masonry (shortest-column placement)

   Progressive enhancement over the CSS multi-column fallback:
   places each artwork into whichever column is currently shortest
   (the Pinterest / Unsplash algorithm) for tight, even bottoms.

   Tile heights are predicted from each image's intrinsic width/height
   attributes, so balancing needs no per-item reflow. The original DOM
   order is cached once, so every re-layout stays in source order.

   Works on ANY grid marked `data-ak-masonry`, so multiple artwork grids
   (e.g. the manual `ak-collection-grid` and the collection-driven
   `ak-artwork-collection-grid`) can coexist on one page.
   ============================================================ */

(function () {
  'use strict';

  var GRID_SELECTOR = '[data-ak-masonry]';
  var MOBILE_MQ = '(max-width: 749px)';

  function allGrids() {
    return Array.prototype.slice.call(document.querySelectorAll(GRID_SELECTOR));
  }

  function colCount(grid) {
    var cs = getComputedStyle(grid);
    var d = parseInt(cs.getPropertyValue('--ak-cols-d'), 10) || 3;
    var m = parseInt(cs.getPropertyValue('--ak-cols-m'), 10) || 2;
    return window.matchMedia(MOBILE_MQ).matches ? m : d;
  }

  /* Predicted tile height (px). All columns share one width, so any error in
     colWidth scales every column equally and never changes which is shortest. */
  function tileHeight(item, colWidth) {
    var img = item.querySelector('img');
    if (img) {
      var w = parseFloat(img.getAttribute('width'));
      var h = parseFloat(img.getAttribute('height'));
      if (w > 0 && h > 0) return colWidth * (h / w);
    }
    return item.offsetHeight || colWidth;
  }

  function layout(grid) {
    var items = grid._akItems;
    if (!items || !items.length) return;

    var cols = colCount(grid);

    /* Build empty columns first so we can read the real column width. */
    grid.textContent = '';
    var colEls = [];
    var heights = [];
    for (var c = 0; c < cols; c++) {
      var col = document.createElement('div');
      col.className = 'ak-masonry-col';
      grid.appendChild(col);
      colEls.push(col);
      heights.push(0);
    }

    var colWidth = colEls[0].clientWidth || grid.clientWidth / cols;

    for (var i = 0; i < items.length; i++) {
      var min = 0;
      for (var j = 1; j < cols; j++) {
        if (heights[j] < heights[min]) min = j;
      }
      colEls[min].appendChild(items[i]);
      heights[min] += tileHeight(items[i], colWidth);
    }
  }

  function init(grid) {
    if (!grid) return;
    /* Cache the source order ONCE — after the first layout the items live
       inside columns (column-major), so re-querying would lose sequence. */
    if (!grid._akItems) {
      grid._akItems = Array.prototype.slice.call(
        grid.querySelectorAll('.collection-item')
      );
    }
    grid.classList.add('ak-masonry--js');
    layout(grid);
  }

  /* Debounced relayout on resize (column count / width may change). */
  var raf;
  window.addEventListener(
    'resize',
    function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        allGrids().forEach(function (grid) {
          if (grid._akItems) layout(grid);
        });
      });
    },
    { passive: true }
  );

  /* Theme editor: the section re-renders with fresh nodes on every edit. */
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target || !e.target.querySelectorAll) return;
    var grids = e.target.matches(GRID_SELECTOR)
      ? [e.target]
      : Array.prototype.slice.call(e.target.querySelectorAll(GRID_SELECTOR));
    grids.forEach(function (grid) {
      grid._akItems = null; /* new DOM → drop stale cache */
      init(grid);
    });
  });

  function boot() {
    allGrids().forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
